import { CartItem, VariantType } from './CartItem';
import Dinero from 'dinero.js';
export var CartStatus;
(function (CartStatus) {
    CartStatus[CartStatus["Open"] = 0] = "Open";
    CartStatus[CartStatus["Purchasing"] = 1] = "Purchasing";
    CartStatus[CartStatus["Closed"] = 2] = "Closed";
})(CartStatus || (CartStatus = {}));
function cartStatusFromString(text) {
    switch (text) {
        case "Open": return CartStatus.Open;
        case "Purchasing": return CartStatus.Purchasing;
        case "Closed": return CartStatus.Closed;
    }
    return null;
}
var Cart = /** @class */ (function () {
    function Cart() {
        this.cartItems = [];
    }
    Cart.prototype.setStatus = function (newStatus) {
        return Object.assign(new Cart(), this, {
            status: newStatus
        });
    };
    Cart.prototype.containsProductVariant = function (product, variant) {
        return this.cartItems.some(function (x) { return x.productId === product.id && x.variant.id === variant.id; });
    };
    Cart.prototype.amountOfProductVariant = function (product, variant) {
        return this.cartItems.filter(function (x) { return x.productId === product.id && x.variant.id === variant.id; }).length;
    };
    Cart.prototype.containsProductVariantType = function (variantType) {
        return this.cartItems.some(function (x) { return x.variant.type === variantType; });
    };
    /**
     * Intented to assist in comping carts that only have 0.00 sale products, should only be digital products
     */
    Cart.prototype.isFreeOrder = function () {
        if (this.containsProductVariantType(VariantType.Print)) {
            return false;
        }
        return Cart.getCartTotal(this).getAmount() === 0;
    };
    //TODO: Replace with DTO when we get total from backend
    Cart.getCartTotal = function (cart) {
        var total = Dinero({ amount: 0, currency: 'USD' });
        if (cart === null || cart === void 0 ? void 0 : cart.cartItems) {
            cart.cartItems.forEach(function (x) {
                total = total.add(x.price);
            });
        }
        return total;
    };
    Cart.createFromApi = function (dto) {
        // console.log("CartItems are", dto.cartItems)
        return Object.assign(new Cart(), dto, {
            cartItems: dto.cartItems.map(function (x) { return CartItem.createFromApi(x); }),
            status: cartStatusFromString(dto.status)
        });
    };
    return Cart;
}());
export { Cart };
var CartDTO = /** @class */ (function () {
    function CartDTO() {
        this.cartItems = [];
    }
    return CartDTO;
}());
export { CartDTO };
